export default "__VITE_ASSET__CRHDhhvH__"